const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Rajdhani:wght@400;500;600;700&family=Orbitron:wght@400;600;700;900&display=swap');

  .resume-section {
    position: relative;
    z-index: 1;
    min-height: 60vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 80px 4rem;
    font-family: 'Rajdhani', sans-serif;
    text-align: center;
  }

  .resume-container {
    max-width: 700px;
    width: 100%;
  }

  .resume-label {
    font-family: 'Orbitron', monospace;
    font-size: 0.65rem;
    font-weight: 600;
    color: #ff8c00;
    letter-spacing: 5px;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    margin-bottom: 1rem;
    opacity: 0;
    animation: resFadeUp 0.7s ease 0.1s both;
  }
  .resume-label::before, .resume-label::after { content: ''; width: 50px; height: 1px; }
  .resume-label::before { background: linear-gradient(to right, transparent, #ff8c00); }
  .resume-label::after  { background: linear-gradient(to left,  transparent, #ff8c00); }

  .resume-title {
    font-family: 'Orbitron', monospace;
    font-size: clamp(1.8rem, 4vw, 2.8rem);
    font-weight: 900;
    background: linear-gradient(135deg, #ffffff 0%, #38c8ff 60%, #00aaff 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    filter: drop-shadow(0 0 20px rgba(0,170,255,0.3));
    margin-bottom: 1rem;
    opacity: 0;
    animation: resFadeUp 0.7s ease 0.2s both;
  }

  .resume-subtitle {
    font-size: 1rem;
    color: rgba(232,244,255,0.5);
    line-height: 1.7;
    max-width: 500px;
    margin: 0 auto 2.5rem;
    opacity: 0;
    animation: resFadeUp 0.7s ease 0.3s both;
  }

  .resume-card {
    background: rgba(0, 20, 50, 0.5);
    border: 1px solid rgba(0,170,255,0.15);
    border-top: 1px solid rgba(0,170,255,0.5);
    padding: 2.5rem;
    position: relative;
    margin-bottom: 2rem;
    opacity: 0;
    animation: resFadeUp 0.7s ease 0.4s both;
  }

  .resume-card::before {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0;
    height: 1px;
    background: linear-gradient(to right, transparent, #00aaff, transparent);
  }

  .resume-preview-icon {
    font-size: 3.5rem;
    margin-bottom: 1rem;
    display: block;
    filter: drop-shadow(0 0 15px rgba(0,170,255,0.5));
  }

  .resume-filename {
    font-family: 'Orbitron', monospace;
    font-size: 0.8rem;
    color: #00aaff;
    letter-spacing: 2px;
    margin-bottom: 0.5rem;
  }

  .resume-fileinfo {
    font-size: 0.85rem;
    color: rgba(232,244,255,0.4);
    margin-bottom: 2rem;
  }

  .resume-btns {
    display: flex;
    gap: 1rem;
    justify-content: center;
    flex-wrap: wrap;
  }

  .btn-download {
    padding: 0.85rem 2.2rem;
    background: linear-gradient(135deg, #00aaff, #0055bb);
    color: #fff;
    font-family: 'Rajdhani', sans-serif;
    font-size: 0.9rem;
    font-weight: 700;
    letter-spacing: 2px;
    text-transform: uppercase;
    border: none;
    cursor: pointer;
    clip-path: polygon(10px 0%, 100% 0%, calc(100% - 10px) 100%, 0% 100%);
    box-shadow: 0 0 20px rgba(0,170,255,0.4);
    transition: box-shadow 0.3s, transform 0.2s;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
  }
  .btn-download:hover {
    box-shadow: 0 0 35px rgba(0,170,255,0.7);
    transform: translateY(-2px);
  }

  .btn-view {
    padding: 0.85rem 2.2rem;
    background: transparent;
    color: #ffaa33;
    font-family: 'Rajdhani', sans-serif;
    font-size: 0.9rem;
    font-weight: 700;
    letter-spacing: 2px;
    text-transform: uppercase;
    border: 1px solid rgba(255,140,0,0.4);
    cursor: pointer;
    clip-path: polygon(10px 0%, 100% 0%, calc(100% - 10px) 100%, 0% 100%);
    transition: background 0.3s, box-shadow 0.3s, transform 0.2s;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
  }
  .btn-view:hover {
    background: rgba(255,140,0,0.08);
    box-shadow: 0 0 20px rgba(255,140,0,0.25);
    transform: translateY(-2px);
  }

  .resume-highlights {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1rem;
    opacity: 0;
    animation: resFadeUp 0.7s ease 0.5s both;
  }

  .highlight-chip {
    background: rgba(0,20,50,0.5);
    border: 1px solid rgba(0,170,255,0.12);
    padding: 0.8rem;
    text-align: center;
    position: relative;
  }

  .highlight-chip::before {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0;
    height: 1px;
    background: linear-gradient(to right, transparent, rgba(0,170,255,0.4), transparent);
  }

  .chip-icon { font-size: 1.3rem; display: block; margin-bottom: 0.3rem; }
  .chip-label {
    font-family: 'Orbitron', monospace;
    font-size: 0.6rem;
    color: #00aaff;
    letter-spacing: 1px;
    text-transform: uppercase;
  }

  @keyframes resFadeUp {
    from { opacity: 0; transform: translateY(20px); }
    to   { opacity: 1; transform: translateY(0); }
  }

  @media (max-width: 600px) {
    .resume-section { padding: 80px 1.5rem; }
    .resume-highlights { grid-template-columns: repeat(2, 1fr); }
  }
`;

export default function Resume() {
  // Place your VincentManalo_Resume.pdf in the public/ folder
  const resumeURL = process.env.PUBLIC_URL + '/VincentManalo_Resume.pdf';

  return (
    <section className="resume-section" id="resume">
      <style>{styles}</style>
      <div className="resume-container">

        <p className="resume-label">My Documents</p>
        <h2 className="resume-title">Resume</h2>
        <p className="resume-subtitle">
          Download or view my professional resume containing my education,
          skills, projects, and certifications.
        </p>

        <div className="resume-card">
          <span className="resume-preview-icon">📄</span>
          <p className="resume-filename">VincentManalo_Resume.pdf</p>
          <p className="resume-fileinfo">BS Computer Engineering  |  Updated 2025</p>

          <div className="resume-btns">
            <a href={resumeURL} download="VincentManalo_Resume.pdf" className="btn-download">
              ⬇ Download PDF
            </a>
            <a href={resumeURL} target="_blank" rel="noreferrer" className="btn-view">
              👁 View Resume
            </a>
          </div>
        </div>

        <div className="resume-highlights">
          {[
            { icon: '🎓', label: 'Education' },
            { icon: '💻', label: 'Skills' },
            { icon: '🚀', label: 'Projects' },
            { icon: '🏆', label: 'Certifications' },
            { icon: '🎯', label: 'Objective' },
            { icon: '🌐', label: 'Languages' },
          ].map((c, i) => (
            <div className="highlight-chip" key={i}>
              <span className="chip-icon">{c.icon}</span>
              <span className="chip-label">{c.label}</span>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}